<template>
  <main class="home">
    <div class="welcome-container">
      <h1>Welcome</h1>
      <p>Explore more about me, my family or look at silly coding projects I have been playing with.</p>
    </div>

    <div class="sections-container">
      <div class="sections-grid">
        <button class="section-card" @click="$emit('change-component', 'Family')">
          <span class="section-icon">👨‍👩‍👧‍👦</span>
          <h3>Family</h3>
          <p>Learn about me and my family</p>
        </button>

        <button class="section-card" @click="$emit('change-component', 'Playground')">
          <span class="section-icon">🎮</span>
          <h3>Playground</h3>
          <p>Explore coding projects</p>
        </button>

        <a href="https://www.linkedin.com/in/aleksandergolubev/" target="_blank" rel="noopener noreferrer" class="section-card">
          <span class="section-icon">💼</span>
          <h3>LinkedIn</h3>
          <p>Connect with me</p>
        </a>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'Home',
  emits: ['change-component']
}
</script>

<style scoped>
main {
  display: flex;
  flex-direction: column;
  padding: 40px 20px;
}

.welcome-container {
  text-align: center;
  max-width: 600px;
  margin: 0 auto 50px;
}

h1 {
  font-size: 2.5rem;
  margin-bottom: 20px;
  margin-top: 0;
  color: #333;
}

.welcome-container > p {
  font-size: 1.1rem;
  color: #666;
  line-height: 1.6;
}

.sections-container {
  max-width: 900px;
  margin: 50px auto 0;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
}

.sections-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  width: 100%;
}

.section-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 30px 20px;
  border: 2px solid #ddd;
  border-radius: 12px;
  background: white;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  text-decoration: none;
  color: inherit;
}

.section-card:hover {
  border-color: #4CAF50;
  box-shadow: 0 4px 16px rgba(76, 175, 80, 0.15);
  transform: translateY(-4px);
}

.section-card:active {
  transform: translateY(-2px);
}

.section-icon {
  font-size: 3rem;
  display: block;
}

.section-card h3 {
  font-size: 1.2rem;
  margin: 0;
  color: #333;
}

.section-card p {
  font-size: 0.9rem;
  color: #666;
  margin: 0;
}

@media (max-width: 768px) {
  main {
    padding: 20px;
  }

  .welcome-container {
    margin-bottom: 30px;
  }

  h1 {
    font-size: 1.8rem;
  }

  .welcome-container > p {
    font-size: 1rem;
  }

  .sections-grid {
    grid-template-columns: 1fr;
  }

  .section-card {
    padding: 20px 15px;
  }

  .section-icon {
    font-size: 2.5rem;
  }

  .section-card h3 {
    font-size: 1.1rem;
  }
}
</style>
